import { useTranslation } from 'react-i18next'

import { DeleteDialog as BaseDeleteDialog } from 'components/Dialog/DeleteDialog'
import { useDeleteAbTest } from './hooks/useDeleteAbTest'
import { DeleteDialogProps } from './types'

export const DeleteDialog = ({ id, isOpen, setOpen }: DeleteDialogProps): JSX.Element => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'list.actions' })
  const { deleteAbTest, loading } = useDeleteAbTest()

  const onDelete = (): void => {
    deleteAbTest(id)
  }

  return (
    <BaseDeleteDialog
      dialog={{ isOpen, setOpen }}
      i18nResource={t}
      loading={loading}
      onDelete={onDelete}
    />
  )
}
